const apimBaseUrls = {
  development: 'apim.zagforward.com',
  test: 'apim.carvanatech.com',
  uat: 'apim.cvuat.com',
  production: 'apim.carvana.io',
  unknown: '',
};

export const getApimBaseUrl = (environment = process.env.NODE_ENV) => {
  return apimBaseUrls[environment];
}

export default getApimBaseUrl;
